// extracted by mini-css-extract-plugin
export default {"switcher":"KanbanViewSwitcher_switcher__dsdKl","switcher__item":"KanbanViewSwitcher_switcher__item__gYkNH","switcher__item_active":"KanbanViewSwitcher_switcher__item_active__rotN3"};